import PortalCommunication from '../../portal-comms';

export const GET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST = 'GET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST';
export const GET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS = 'GET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS';
export const GET_ACTIVITY_ASSIGN_PREFERENCE_FAILURE = 'GET_ACTIVITY_ASSIGN_PREFERENCE_FAILURE';

export const getActivityAssignPreferences = () =>
    ({ type: GET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST });

export const getActivityAssignPreferencesSuccess = data =>
    ({ type: GET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS, data });

export const getActivityAssignPreferencesFailure = () =>
    ({ type: GET_ACTIVITY_ASSIGN_PREFERENCE_FAILURE });

export const SAVE_ACTIVITY_ASSIGN_PREFERENCE_REQUEST = 'SAVE_ACTIVITY_ASSIGN_PREFERENCE_REQUEST';
export const SAVE_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS = 'SAVE_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS';
export const SAVE_ACTIVITY_ASSIGN_PREFERENCE_FAILURE = 'SAVE_ACTIVITY_ASSIGN_PREFERENCE_FAILURE';

export const saveActivityAssignPreferences = request =>
    ({ type: SAVE_ACTIVITY_ASSIGN_PREFERENCE_REQUEST, request });

export const saveActivityAssignPreferencesSuccess = () => {
    PortalCommunication.navigateToLandingScreen('Settings');
    return { type: SAVE_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS };
};

export const saveActivityAssignPreferencesFailure = () =>
    ({ type: SAVE_ACTIVITY_ASSIGN_PREFERENCE_FAILURE });

export const RESET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST = 'RESET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST';
export const RESET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS = 'RESET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS';
export const RESET_ACTIVITY_ASSIGN_PREFERENCE_FAILURE = 'RESET_ACTIVITY_ASSIGN_PREFERENCE_FAILURE';

export const resetPreferences = request =>
    ({ type: RESET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST, request });

export const resetActivityAssignPreferencesSuccess = () => {
    PortalCommunication.navigateToLandingScreen('Settings');
    return { type: RESET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS };
};

export const resetActivityAssignPreferencesFailure = () =>
    ({ type: RESET_ACTIVITY_ASSIGN_PREFERENCE_FAILURE });



// WEBPACK FOOTER //
// ./app/containers/activity-assign-preference/actions.js